import { Component } from '@angular/core';
import { NotificationsHttpService } from '../../../services/notifications/notifications.http.service';
import { NotificationsHttpUtil } from './notifications.util';
import { StorageUtil } from '../../../utils/storage.util';
import { AuthUtil } from '../../../utils/auth.utils';

@Component({
  moduleId: module.id,
  templateUrl: 'notifications.component.html',
  providers: []
})

export class NotificationsComponent {

  model: any = {};

  pageSize = 10;
  pageNumber = 0;

  pageLoading: boolean = true;
  errorMessage: string;
  serverValidationErrorMessage: any;
  loadBtnStatus

  infinityScrollDisabled: boolean = false;

  constructor(
    private notificationsHttpService: NotificationsHttpService,
    private authUtil: AuthUtil) {
    this.getHistory();
  }

  getHistory() {
    const data = {
      securityToken: StorageUtil.getToken(),
      // pageSize: this.pageSize,
      // pageNumber: this.pageNumber,
      showHistory: 1
    };
    const requestParams = NotificationsHttpUtil.prepareParamsHistory(data);
    this.notificationsHttpService.getHistory(requestParams).subscribe(
      success => {
        if (success) {
          this.pageLoading = false;
          let data = success.json();
          if(this.authUtil.isError(data)) {
            this.errorMessage = this.authUtil.errorMessage(data);
            this.authUtil.checkErrorResponse(data);
          } else {
            this.model = data.response && data.response.items || [];

            if (this.model.length > 0) {
              this.loadBtnStatus = true;
            }
          }
        }
      },
      error => {
        if (error.status === 422) {
          this.serverValidationErrorMessage = error.json().errors;
        } else {
          this.errorMessage = 'Произошла ошибка.';
        }
        this.pageLoading = false;
        this.loadBtnStatus = true;
      },
      () => {
        this.pageLoading = false;
      });
  }

  loadNextHistory() {
    this.infinityScrollDisabled = true;
    this.pageNumber += 1;
    // TODO: refactoring
    this.getNextHistory();
  }

  getNextHistory() {
    // TODO: scroll loading status

    let data = {
      securityToken: StorageUtil.getToken(),
      // pageSize: this.pageSize,
      // pageNumber: this.pageNumber,
      showHistory: 1
    };

    let requestParams = NotificationsHttpUtil.prepareParamsHistory(data);
    this.notificationsHttpService.getHistory(requestParams).subscribe(
      success => {
        if (success) {
          this.pageLoading = false;
          let data = success.json();
          if(this.authUtil.isError(data)) {
            this.errorMessage = this.authUtil.errorMessage(data);
            this.authUtil.checkErrorResponse(data);
          } else {
            let model = data.response && data.response.items || [];
            this.model.push.apply(this.model, model);
            this.infinityScrollDisabled = false;
            this.loadBtnStatus = model.length > 0;
          }
        }
      },
      error => {
        if (error.status === 422) {
          this.serverValidationErrorMessage = error.json().errors;
        } else {
          this.errorMessage = 'Произошла ошибка.';
        }
        this.pageLoading = false;
        this.loadBtnStatus = true;
      },
      () => {
        this.pageLoading = false;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/notifications/notifications.component.ts